import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { FlexLayoutModule } from '@angular/flex-layout';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  ToastModule, MDBBootstrapModulesPro, MDBSpinningPreloader, DropdownModule,
} from 'ng-uikit-pro-standard';
import { SharedModule } from './shared/shared.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { RecaptchaModule } from 'ng-recaptcha';
import { ImageWidthToMediaPipe } from './image-width-to-media.pipe';

import { OAuthModule } from 'angular-oauth2-oidc';
import { RedirectComponent } from './redirect/redirect.component';
import { TokenInterceptor } from './token.interceptor';
import * as fromRedirect from './redirect/reducers';
import { RedirectEffects } from './redirect/redirect.effects';
import * as fromUserConfirmed from './userconfirmed.reducer';

import {LayoutModule} from '@angular/cdk/layout';

@NgModule({
  declarations: [
    AppComponent,
    RedirectComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production }),
    EffectsModule.forRoot([]),
    StoreModule.forRoot({}, {}),
    MDBBootstrapModulesPro.forRoot(),
    ToastModule.forRoot(),
    DropdownModule.forRoot(),
    SharedModule,
    FormsModule,
    LayoutModule,
    ReactiveFormsModule,
    // OAuthModule.forRoot(),
    RecaptchaModule,
    StoreDevtoolsModule.instrument(),
    // StoreModule.forRoot(reducers, {
    //   metaReducers,
    //   runtimeChecks: {
    //     strictStateImmutability: true,
    //     strictActionImmutability: true,
    //   }
    // }),
    // !environment.production ? StoreDevtoolsModule.instrument() : [],
    StoreModule.forFeature(
      fromRedirect.redirectFeatureKey,
      fromRedirect.reducer,
      { metaReducers: fromRedirect.metaReducers }),
    StoreModule.forFeature(
      fromUserConfirmed.userconfirmedFeatureKey,
      fromUserConfirmed.reducer
    ),
    EffectsModule.forFeature([RedirectEffects]),
    StoreRouterConnectingModule.forRoot(),
  ],
  providers: [
    {provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
